{
    "NAME": "Liste des utilisateursLangue",
    "UsersList_Column_FullName": "Nom et prénom",
    "UsersList_Column_Username": "Nom d'utilisateur",
    "UsersList_Column_LockOut": "Enfermé dehors",
    "UsersList_Column_ActivityLastLogon": "Activité\/Dernière connexion",
    "UsersList_Tooltip_LastLogon_Label": "Dernière connexion",
    "UsersList_LastLogon_None": "Aucune donnée",
    "UsersList_Column_Permissions": "Autorisations",
    "UsersList_Column_TelSys": "Serveur de téléphonie",
    "UsersList_LockOut_Yes": "Oui",
    "UsersList_LockOut_No": "Non",
    "UsersList_Filter_UserType_Label": "Type d'utilisateur",
    "UsersList_UserType_All": "Tous",
    "UsersList_UserType_ServiceWide": "Service à l'échelle de l'ensemble du service",
    "UsersList_UserType_SystemWide": "Système global",
    "UsersList_UserType_Detached": "Détaché",
    "UsersList_UserType_AdminInclusive": "Administrateurs (y compris)",
    "UsersList_UserType_AdminExclusive": "Administrateurs (exclusifs)",
    "UsersList_UserType_ReportingHistoricOnly": "Rapports (historiques uniquement)",
    "UsersList_UserType_ReportingBLF": "Rapport (BLF)",
    "UsersList_UserType_ReportingStd": "Rapport (norme)",
    "UsersList_UserType_ReportingACD": "Rapport (ACD)",
    "UsersList_UserType_ReportingMobileAppAdvanced": "Signalement (application mobile avancée)",
    "UsersList_UserType_SignedInNow": "Connecté(e) maintenant",
    "UsersList_UserType_SignedInToday": "Connecté aujourd'hui",
    "UsersList_UserType_SignedInThisWeek": "Inscription cette semaine",
    "UsersList_UserType_SignedInThisMonth": "Signé ce mois-ci",
    "UsersList_UserType_SignedInNever": "Je ne me suis jamais connecté",
    "UsersList_UserType_ActivityToday": "Activité aujourd'hui",
    "UsersList_UserType_ActivityThisWeek": "Activité cette semaine",
    "UsersList_UserType_ActivityThisMonth": "Activité ce mois-ci",
    "UsersList_UserType_ActivityNone": "Aucune activité",
    "UsersList_CopyReports_Button": "Copier les rapports à",
    "UsersList_BulkAdd_Button": "Ajout en masse",
    "UsersList_SignInAs_Button": "Se connecter en tant que",
    "UsersList_SignInAs_Confirm": "Se connecter en tant que **{}** ? Vous continuerez à utiliser ce compte utilisateur dans cette session de navigation.",
    "UsersList_CopyReports_Dialog_Title": "Copier les rapports de **{} ({})**",
    "UsersList_CopyReports_Step_Reports": "Rapports",
    "UsersList_CopyReports_Step_Targets": "Utilisateurs cibles",
    "UsersList_CopyReports_Step_Confirm": "Confirmer",
    "UsersList_CopyReports_Intro_Reports": "Sélectionnez un ou plusieurs rapports à copier à partir de **{}**.",
    "UsersList_CopyReports_Intro_Targets": "Sélectionnez un ou plusieurs utilisateurs qui devraient recevoir des copies de ces rapports.",
    "UsersList_CopyReports_Confirm_Summary": "Vous copierez **{}** rapport(s) à **{}** utilisateur(s).",
    "UsersList_CopyReports_Confirm_Report_Label": "Copie du rapport **{}** :",
    "UsersList_CopyReports_Confirm_Reports_Label": "Copie des rapports **{}** :",
    "UsersList_CopyReports_Confirm_Target_Label": "À l'utilisateur **{}** :",
    "UsersList_CopyReports_Confirm_Targets_Label": "Aux utilisateurs de **{}** :",
    "UsersList_CopyReports_Overwrite_Label": "Remplacer les rapports existants sur les utilisateurs cibles en cas de conflit de noms.",
    "UsersList_CopyReports_Success": "Rapports copiés avec succès.",
    "UsersList_CopyReports_Cancel": "Annuler",
    "UsersList_CopyReports_Back": "Dos",
    "UsersList_CopyReports_Next": "Suivant",
    "UsersList_CopyReports_Copy": "Copier les rapports",
    "UsersList_CopyReports_Column_Folder": "Dossier",
    "UsersList_CopyReports_Column_ReportName": "Rapport",
    "UsersList_CopyReports_Column_Type": "Taper",
    "UsersList_CopyReports_Column_Username": "Nom d'utilisateur",
    "UsersList_CopyReports_Column_FullName": "Nom et prénom",
    "UsersList_CopyReports_Empty_Reports": "Aucun rapport n'est disponible pour cet utilisateur.",
    "UsersList_CopyReports_Empty_Targets": "Aucun utilisateur cible éligible n'est concerné par cette opération de copie."
}